import React from "react";
import { Paper, CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import { makeStyles } from "@mui/styles";
import { createTheme, responsiveFontSizes } from "@mui/material";

let theme = createTheme({
});

theme = responsiveFontSizes(theme);

const useStyle = makeStyles((theme: any) => ({
  root: {
    borderRadius: "16px",
    height: "fit-content",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(15),
  },
  paper: {
    borderRadius: "16px",
    height: "fit-content",
    width: "50vw",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: "auto",
    marginRight: "auto",
    padding: theme.spacing(4),
    [theme.breakpoints.down("lg")]: {
      //600+
      overflowY: "auto",
      padding: theme.spacing(3),
      width: "70vw",
      height: "80vh",
    },
    [theme.breakpoints.down("sm")]: {
      //phones 600-
      overflow: "auto",
      width: "70vw",
      padding: theme.spacing(2),
      height: "80vh",
    },
  },
}));

export default function ModalLayout(props: any) {
  const { children } = props;
  const classes = useStyle();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Paper className={classes.paper}>{children}</Paper>
    </ThemeProvider>
  );
}
